import React, {Component} from 'react';
import {connect} from 'react-redux';
import Slider from 'react-slick';
import './css/Carousel.styl';
import SVGIcon from '../../../../../assets/svg-icons/icons';
import helperImages from './assets/fallBackImages/imageHelper';

export class Carousel extends Component {
  static propTypes = {
    images: React.PropTypes.array.isRequired,
    funeralHome: React.PropTypes.object,
  };

  getImages() {
    const images = this.props.images
      .filter(image => image.includeInCarousel)
      .map(image => image.url);

    return this.addImagesIfLessThanThree(images);
  }

  addImagesIfLessThanThree = images => {
    const {funeralHomeId = 0} = this.props.funeralHome;
    const seriesStart = Math.floor((funeralHomeId % 10) / 2);
    const fillerImages = helperImages();

    if (images.length === 0) {
      return [
        fillerImages[seriesStart],
        fillerImages[seriesStart + 1],
        fillerImages[seriesStart + 2],
      ];
    }
    if (images.length === 1) {
      return [
        images[0],
        fillerImages[seriesStart + 1],
        fillerImages[seriesStart + 2],
      ];
    }
    if (images.length === 2) {
      return [images[0], fillerImages[seriesStart], images[1]];
    }
    return images;
  };

  cleanVideoUrl = link => link.replace(/\/watch\?v=/, '/embed/');

  PrevArrow = props => {
    const {onClick} = props;

    return (
      <div className="slick-arrow slick-prev" onClick={onClick}>
        <SVGIcon
          className="funeral-home-amenities__svg"
          name="leftArrow"
          fill="#ffffff"
          size="64px"
        />
      </div>
    );
  };

  NextArrow = props => {
    const {onClick} = props;

    return (
      <div className="slick-arrow slick-next" onClick={onClick}>
        <SVGIcon
          className="funeral-home-amenities__svg"
          name="rightArrow"
          fill="#ffffff"
          size="64px"
        />
      </div>
    );
  };

  render() {
    const NextArrow = this.NextArrow;
    const PrevArrow = this.PrevArrow;

    const sliderUrls = this.getImages().map((url, index) => {
      if (url.toLowerCase().match(/png$|jpg$|gif$|svg$/)) {
        return <img src={url} key={index} />;
      }

      const videoUrl = this.cleanVideoUrl(url);

      return (
        <iframe
          key={index}
          frameBorder="0"
          height="284px"
          allowFullScreen="allowfullscreen"
          src={videoUrl}
        />
      );
    });

    const settingsForMobile = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      variableWidth: false,
      speed: 500,
      appendDots: dots => (
        <div>
          <ul style={{margin: '0px'}}>{dots}</ul>
        </div>
      ),
      customPaging: () => (
        <div className="dots">
          <SVGIcon
            className="slick-list-dots"
            name="circle"
            fill="#ffffff"
            size="14px"
          />
        </div>
      ),
    };

    const settingsForDesktop = {
      className: 'slider variable-width multiple-images',
      dots: false,
      infinite: true,
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      arrows: true,
      speed: 500,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    };

    const settings =
      typeof window !== 'undefined' &&
      window.matchMedia('(min-width: 768px)').matches
        ? settingsForDesktop
        : settingsForMobile;

    return (
      <div className="carousel">
        {sliderUrls.length > 0 ? (
          <Slider {...settings}>{sliderUrls}</Slider>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  funeralHome: state.funeralHomeStore,
  images: state.funeralHomeStore.images,
});

export default connect(mapStateToProps)(Carousel);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Carousel/index.js